import { Avatar } from '@components/Avatar'
import { useNames } from '@hooks/names'
import { useFindProfile } from '@hooks/profile'

import { HeaderContainer, UserInfoContainer } from './styles'
import { Label, Title } from '../InformationComponents/styles'

export function Header() {
  const { getFirstNameLetter } = useNames()

  const { data: rawUser } = useFindProfile()
  const user = rawUser ?? ({} as NonNullable<typeof rawUser>)

  return (
    <HeaderContainer>
      <Avatar height={60} width={60}>
        {getFirstNameLetter(user?.displayName)}
      </Avatar>
      <UserInfoContainer>
        <Title>{user?.displayName}</Title>
        <Label>{user?.selectedSite.name}</Label>
      </UserInfoContainer>
    </HeaderContainer>
  )
}
